import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import elementEnLocale from 'element-ui/lib/locale/lang/en'; // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'; // element-ui lang

// import elementJaLocale from 'element-ui/lib/locale/lang/ja'// element-ui lang
import enLocale from './en';
import zhLocale from './zh';
// import esLocale from './es'
// import jaLocale from './ja'
//全局函数1
// 服务器上报使用翻译
Vue.prototype.langTxt = function(value) {
	let chooseLanguage = Cookies.get('language');
	if (typeof chooseLanguage == 'undefined' || !chooseLanguage) {
		chooseLanguage = 'zh';
	}
	let typeName = value;
	let isTranslate = true;
	var langList = this.$store.getters.commonLanguage;
	if (langList && chooseLanguage != 'zh') {
		for (let item of langList) {
			if (value == item.name && item.translate) {
				typeName = item.translate;
				isTranslate = false;
				break;
			}
			if (item.name == value) {
				isTranslate = false;
			}
		}
	}
	// 上报翻译数据
	setTimeout(() => {
		if (langList && typeName == value && isTranslate && chooseLanguage != 'zh') {
			var postData = {
				name: value,
				platform: 'admin'
			};
			this.request.post('/common-language-report', postData).then((ret) => {
				console.log(ret);
			});
		}
	}, 1000);

	return typeName;
};

Vue.use(VueI18n);

const messages = {
	en: {
		...enLocale,
		...elementEnLocale
	},
	zh: {
		...zhLocale,
		...elementZhLocale
	}
	// es: {
	//   ...esLocale,
	//   ...elementEsLocale
	// },
	// ja: {
	//   ...jaLocale,
	//   ...elementJaLocale
	// }
};
export function getLanguage() {
	const chooseLanguage = Cookies.get('language');
	if (chooseLanguage) return chooseLanguage;
	// if has not choose language
	const language = (navigator.language || navigator.browserLanguage).toLowerCase();
	const locales = Object.keys(messages);
	for (const locale of locales) {
		if (language.indexOf(locale) > -1) {
			return locale;
		}
	}
	return 'en';
}

const i18n = new VueI18n({
	// options: en | zh | es
	locale: getLanguage(),
	// set locale messages
	messages,
	silentTranslationWarn: true
});

export default i18n;
